module.exports = __webpack_public_path__ + "25f84b53d0f3bd4241f88280b2581350.png";